import { useMemo } from 'react';
import { mapToStandardColor } from 'constants/colors';

interface Tag {
  id: string;
  name: string;
  description?: string;
  color: string;
}

interface EnhancedTag extends Tag {
  backgroundColor: string;
  textColor: string;
  colorLabel: string;
}

/**
 * Custom hook to enhance tags with standardized color information
 */
const useTagsCompatibilityDisplay = (tags: Tag[]): EnhancedTag[] => {
  return useMemo(() => {
    return tags.map(tag => {
      const colorMapping = mapToStandardColor(tag.color);

      return {
        ...tag,
        backgroundColor: colorMapping.background,
        textColor: colorMapping.text,
        colorLabel: colorMapping.label
      };
    });
  }, [tags]);
};

export default useTagsCompatibilityDisplay;
